// Coupons an agent may offer, keyed by the shortest plan (payment_terms) each one
// is allowed on. The cap grows with the commitment — 3-month up to $50, 6-month up
// to $75, 12-month up to $100 — and any smaller coupon also works on a longer plan.
// Monthly gets none. Picking one still goes through /validate-coupon, so a coupon
// not set up for that plan on this brand shows as invalid rather than discounting.
const MIN_TERMS = {
    '25OFF': 3,
    '50OFF': 3,
    '75OFF': 6,
    '100OFF': 12,
};

// Limited promo coupons, offered ONLY on the plan lengths listed (not on longer
// ones). Their usage cap lives on the backend coupon rows (max_use), which
// /validate-coupon enforces — once used up they show as invalid.
const EXACT_TERMS = {
    'CC75': [3],
    'CC100': [6],
    'CC150': [6, 12],
};

export function couponsForTerms(terms) {
    const t = parseInt(terms, 10);
    if (!t) return [];
    return Object.keys(MIN_TERMS).filter((code) => t >= MIN_TERMS[code])
        .concat(Object.keys(EXACT_TERMS).filter((code) => EXACT_TERMS[code].includes(t)));
}
